var highlighted = 'q6x4vh2';
var input = 'q6x4vh0';
var label = 'q6x4vh3';
var primary = 'q6x4vh1';
var size = {md:'q6x4vh5',lg:'q6x4vh6'};
var toggleButton = 'q6x4vh4';

export { highlighted, input, label, primary, size, toggleButton };
//# sourceMappingURL=toggle-button.css.js.map
